import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { ACCOUNT, ACCOUNT_CREATE, ACCOUNT_LIST, ACCOUNT_PROFILE_UPDATE, GLOBAL_STATE } from '../constants/actionTypes'

const accountsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const accountSelector = createSelector(accountsSelector, data => data[ACCOUNT])

export const accountCreateSelector = createSelector(accountsSelector, data => data[ACCOUNT_CREATE])

export const accountListSelector = createSelector(accountsSelector, data => data[ACCOUNT_LIST])

export const accountProfileUpdateSelector = createSelector(accountsSelector, data => data[ACCOUNT_PROFILE_UPDATE])
